
import Static from "../../components/Static";
import headerImage from "../../assets/staticSection/azienda_sede.webp";
import { Helmet } from "react-helmet";

export default function Reclami() {
    return <>
    <Helmet>
            <title>Reclami - Careisgold</title>
          
          </Helmet>
        <Static 
        headerImage={headerImage}
        logoTransp=''
        // title='Reclami'
        // description={`<p>Il nostro motto è: l’Oro accessibile a tutti, prima di tutti. Grazie a Careisgold, infatti,</p><h1>chiunque può accedere al Bene Rifugio per eccellenza con semplicità e sicurezza.</h1>`}
        logoPosition='left-[130vh] top-[30vh] w-[110vh]'
      />
        <section className="w-full bg-secondary-color text-left bg-white text-black">
            <div className="max-w-4xl mx-auto py-36 px-5 ">
                <div className="">
                    <div className="">
                        <h1 className="text-4xl font-semibold  mt-10 mb-5 uppercase">
                            RECLAMI
                        </h1>
                        <hr className="my-10"></hr>
                        <p>
                            CAREISGOLD S.p.A. pone la massima attenzione alla tutela dei propri Clienti e alla qualità dei servizi offerti.
                            In caso di insoddisfazione, disservizi o contestazioni relativi ai rapporti intrattenuti con la Società, ciascun Cliente ha diritto a presentare un reclamo formale, che verrà gestito con la dovuta professionalità, imparzialità e tempestività, in conformità alla normativa vigente. Ogni segnalazione è recepita costruttivamente e considerata con la massima attenzione.
                        </p>

                        <div>
                            <h2 className="text-2xl font-semibold  mt-10 mb-5">
                                Modalità di presentazione del reclamo
                            </h2>
                            <p>
                                Il reclamo deve essere formulato in forma scritta e può essere inviato, alternativamente, tramite:
                            </p>
                            <ul className="mt-10">
                                <li>
                                    <span className="font-bold">Posta ordinaria all’indirizzo:</span>  CAREISGOLD S.p.A. Via Monte Baldo, 14/D - 37069 Villafranca di Verona VR
                                </li>
                                <li>
                                    <span className="font-bold">E-mail:</span> <a href="mailto:reclami@careisgold.it" target="_blank" rel="noreferrer">reclami@careisgold.it</a>
                                </li>
                                <li>
                                    <span className="font-bold">PEC:</span> <a href="mailto:careisgoldspa@pec.careisgold.it" target="_blank" rel="noreferrer">careisgoldspa@pec.careisgold.it</a>
                                </li>
                            </ul>
                            <p className="mt-10">
                                Per consentire una gestione efficace del reclamo, si invita il Cliente a indicare chiaramente:
                            </p>
                            <ul className="mt-2">
                                <li>
                                    I propri dati identificativi e di contatto;
                                </li>
                                <li>
                                    Una descrizione dettagliata dei fatti contestati;
                                </li>
                                <li>
                                    Eventuale documentazione a supporto.
                                </li>
                            </ul>
                        </div>
                        
                        <h3 className="mt-10 mb-1 font-bold">Tempi di risposta</h3>
                        <p>
                            Una volta ricevuto, il reclamo viene preso in carico e analizzato dalla Società, entro 30 giorni.  
                        </p>
                        <h3 className="mt-10 mb-1 font-bold">Tutela del Cliente</h3>
                        <p>
                            La gestione dei reclami avviene secondo principi di trasparenza, correttezza e tracciabilità.
                        </p>
                        
                        <p className="mt-10 mb-5">Qualora il Cliente non ritenesse soddisfacente la risposta ricevuta, potrà valutare ulteriori azioni di tutela previste dall’ordinamento.</p>
                        
                        <hr className="my-10"></hr>
                    </div>
                </div>
            </div>
        </section>
    </>

}